export class RoomsModel{
  roomCode ='';
  roomName = '';
  roomType =  '';
  roomNotes = '';
  userID = '';
  modifiedDate = '2021-01-01';
  compCode = '1';


}
